import { render, staticRenderFns } from "./PelleRiftBar.vue?vue&type=template&id=13d34072&scoped=true&"
import script from "./PelleRiftBar.vue?vue&type=script&lang=js&"
export * from "./PelleRiftBar.vue?vue&type=script&lang=js&"
import style0 from "./PelleRiftBar.vue?vue&type=style&index=0&id=13d34072&scoped=true&lang=css&"
import style1 from "./PelleRiftBar.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d34072",
  null
  
)

export default component.exports